import Vue from 'vue'
import Reco from './Panel-reco.vue'
import Anli from './Panel-anli.vue'
import List from './Page-list.vue'
import Common from './common.vue'

import axios from 'axios'

Vue.config.productionTip = false

const BUS = new Vue();
Vue.prototype.$http = axios


//axios 请求失败重新请求
axios.defaults.timeout=3000
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if(!config || !config.retry) return Promise.reject(err);
    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;
    // Check if we've maxed out the total number of retries
    if(config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err);
    }
    // Increase the retry count
    config.__retryCount += 1;
    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1);
    });
    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        return axios(config);
    });
});


//游戏详情-anli
window.commentDetail=function(){
  new Vue({
    render: h => h(Anli),
    data() {
      return {BUS}
    }
  }).$mount("#commentAnli");
  new Vue({
    render: h => h(Reco),
    data() {
      return {BUS}
    }
  }).$mount("#commentReco");
}


// 定义一个Vue全局的过滤器，名字叫做  numFormat
Vue.filter('numFormat',function(num){
  if(num>10e4){       
    return (num / 10e3).toFixed(1)+'W'
  }else if(num>10e3){
    return (num / 10e3).toFixed(2)+'W'
  }
  return num
})


window.comAnli=new Vue({
  render: h => h(Anli)
})

//游戏详情-评论推荐
window.comReco=new Vue({
  render: h => h(Reco)
})

window.AnliTemp=null;


//游戏详情-评论面板
window.comList=new Vue({
  render: h => h(List)
})

//评论常见列表
window.comCommon=new Vue({
  render: h => h(Common)
})
